import React, { useState } from "react";
import { Row, Col, Button, Drawer, Menu, Tooltip } from "antd";
import { useOktaAuth } from "@okta/okta-react";
import { Link } from "react-router-dom"; // Import React Router for navigation
import {
  SettingOutlined,
  CompassOutlined,
  MenuOutlined,
  DashboardOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

const { SubMenu } = Menu;
const client =
  window.location.host.startsWith("vw.") ||
  window.location.href.includes("client=vw")
    ? "vw"
    : "cm";

//different menu items by client
const MenuToggle = ({
  drawerTitle = "Menu",
  drawerWidth = 300,
  allCollections = [],
  menuItems = client === "cm"
    ? [
        {
          key: "home",
          label: "Daily run overview",
          path: "/",
          icon: <DashboardOutlined />,
          children: allCollections.map((child, index) => ({
            key: child.name,
            label: child.name,
            path: `/${child.name.toLowerCase()}`,
          })),
        },
        {
          key: "profile",
          label: "Campaign monitoring",
          path: "/campaign-monitoring",
          icon: <CompassOutlined />,
        },
        {
          key: "settings",
          label: "Settings",
          icon: <SettingOutlined />,
          children: [
            {
              key: "testcatalog",
              label: "Test catalog",
              path: `/test-catalog`,
            },
          ],
        },
      ]
    : [
        {
          key: "home",
          label: "Daily run overview",
          path: "/",
          icon: <DashboardOutlined />,
          children: allCollections.map((child, index) => ({
            key: child.name,
            label: child.name,
            path: `/${child.name.toLowerCase()}`,
          })),
        },
        {
          key: "settings",
          label: "Settings",
          icon: <SettingOutlined />,
          children: [
            {
              key: "testcatalog",
              label: "Test catalog",
              path: `/test-catalog`,
            },
          ],
        },
      ],
}) => {
  const [open, setOpen] = useState(false);
  const { oktaAuth, authState } = useOktaAuth(); // Get Okta authentication instance

  const handleLogout = () => {
    oktaAuth.signOut(); // Log the user out of Okta
  };

  return (
    <>
      {/* Banner Row */}
      <Row
        justify="space-between"
        align="middle"
        style={{
          padding: "0 20px",
        }}
      >
        <Col>
          <Tooltip title="Menu">
            <Button
              type="text"
              icon={
                <MenuOutlined
                  style={{
                    fontFamily: `${client}Regular`,
                    color: "#F7FAF2",
                    fontSize: "1.6rem",
                    padding: "0 10px",
                  }}
                />
              }
              onClick={() => setOpen(true)}
              style={{ color: "#fff" }}
            />
          </Tooltip>
        </Col>
      </Row>

      {/* Side Drawer */}
      <Drawer
        title={drawerTitle}
        placement="left"
        onClose={() => setOpen(false)}
        open={open}
        width={drawerWidth}
        style={{ fontFamily: `${client}Regular`, background: "#F7FAF2" }}
        //style={{ fontFamily: `${client}Regular`,background: client === "vw" ? "#F8F5F2" : "#F7FAF2",}}
      >
        <Menu
          mode="inline"
          defaultOpenKeys={menuItems
            .filter((item) => item.children)
            .map((item) => item.key)}
          style={{
            fontFamily: `${client}Regular`,
            background: "#F7FAF2",
            //background: client === "vw" ? "#F8F5F2" : "#F7FAF2",
          }}
        >
          {menuItems.map((item) =>
            item.children && item.children.length < 8 ? (
              <SubMenu
                key={item.key}
                icon={<span style={{ color: "black" }}>{item.icon}</span>}
                title={
                  <Link
                    to={item.path}
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    {item.label}
                  </Link>
                }
              >
                {item.children.map((subItem) => (
                  <Menu.Item key={subItem.key}>
                    <Link to={subItem.path} style={{ color: "black" }}>
                      {subItem.label}
                    </Link>
                  </Menu.Item>
                ))}
              </SubMenu>
            ) : (
              <Menu.Item
                key={item.key}
                icon={<span style={{ color: "black" }}>{item.icon}</span>}
              >
                <Link to={item.path} style={{ color: "black" }}>
                  {item.label}
                </Link>
              </Menu.Item>
            ),
          )}
        </Menu>
        <div
          style={{
            position: "fixed",
            top: "14px",
            right: "0px",
            width: "calc(100% - 260px)",
          }}
        >
          <Tooltip title="Logout">
            <LogoutOutlined
              style={{
                fontFamily: `${client}Bold`,
                fontSize: "28px",
                color: "black",
                cursor: "pointer",
              }}
              onClick={handleLogout}
            />
          </Tooltip>
        </div>
      </Drawer>
    </>
  );
};

export default MenuToggle;
